import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/system';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { injectIntl, FormattedMessage } from 'react-intl';

import messages from './messagesSleeperSupplements';
import inlineStyles from './styles';

const StyledDialogActions = styled(DialogActions)({
	...inlineStyles.dialogActions,
});

const SleeperSupplementActions = ({
	onDiscardSleeperSupplements,
	onChangeSleeperSupplements,
	tempSelectedSupplements,
}) => {
	const handleSave = () => {
		onChangeSleeperSupplements(tempSelectedSupplements);
	};

	const handleDiscard = () => {
		onDiscardSleeperSupplements();
	};

	return (
		<StyledDialogActions>
			<Button onClick={handleDiscard} color="secondary">
				<FormattedMessage {...messages.cancelButton} />
			</Button>
			<Button onClick={handleSave} color="primary" variant="contained">
				<FormattedMessage {...messages.saveButton} />
			</Button>
		</StyledDialogActions>
	);
};

SleeperSupplementActions.propTypes = {
	onDiscardSleeperSupplements: PropTypes.func.isRequired,
	onChangeSleeperSupplements: PropTypes.func.isRequired,
	tempSelectedSupplements: PropTypes.array.isRequired,
};

export { SleeperSupplementActions as SleeperSupplementActionsAlias };

export default injectIntl(SleeperSupplementActions);
